






























































import { IBitrixGuest } from "@/@types/admin/guest/user";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { auth } from "@/config/host.config";
import { getBirthday } from "@/services/dateTime/date-time-fofmat";
import { ICruise } from "@/@types/cruiseOffers/cruiseList";
import { cruiseOffers as cruises } from "@/config/host.config";
import { isDateLessOrEqualThanToday } from "@/services/dateTime/dateLessOrEqualThanToday";

import BitrixTableTd from "./bitrix_table_td.vue";
import StandartModal from "@/components/app/standart-modal.vue";

@Component({ components: { StandartModal, BitrixTableTd } })
export default class Bitrix extends Vue {
  @Prop({ type: Array, default: () => [] }) cruises!: Array<ICruise>;
  bitrixList: Array<IBitrixGuest> = [];
  spiner = false;
  spinnerCruise = false;
  cruise_id = "";

  get current_cruise(): ICruise | null {
    if (!this.cruises || !this.cruises.length) return null;
    const cruise = this.cruises.find((el) => el._id == this.cruise_id);
    return cruise ? cruise : null;
  }

  get ar(): string {
    return this.current_cruise ? this.date(this.current_cruise.start_date) : "";
  }

  get de(): string {
    return this.current_cruise ? this.date(this.current_cruise.end_date) : "";
  }

  get cruiseList(): Array<ICruise> {
    return this.cruises.filter((el) => {
      if (!isDateLessOrEqualThanToday(el.end_date)) return el;
    });
  }

  date(date: Date | string): string {
    return getBirthday(date);
  }

  strToDate(str: string): Date {
    const [day, month, year] = str.split(".");
    const date = new Date(Number(year), Number(month) - 1, Number(day));
    return date;
  }

  async getGuests(id: string): Promise<void> {
    this.bitrixList = [];
    this.spiner = true;
    const uri = auth.bitrix;
    const params = { cruiseid: id };
    try {
      const res = await this.$axios.get(uri, { params });
      this.spiner = false;
      if (res.status === 200) {
        this.bitrixList = res.data;

        if (!this.ar || !this.de) return;
        this.bitrixList.forEach((el) => {
          if (!el.stay_data) return;
          el.stay_data.arrival = this.strToDate(this.ar);
          el.stay_data.departure = this.strToDate(this.de);
        });
      }
    } catch (e) {
      this.spiner = false;
      console.log(e);
    }
  }

  getDate(date: Date | string): string {
    return getBirthday(date);
  }

  async updateCruise(): Promise<void> {
    this.spinnerCruise = true;
    const uri = cruises.mainAPI;

    try {
      const updateCruises = await this.$axios.put(uri);

      if (updateCruises.status === 200) {
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("error.200")),
        });
        this.spinnerCruise = false;
        this.$emit("getCruiseList");
      }
    } catch (e) {
      console.log(e);
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("alerts.emptyUpdate")),
        type: "warn",
      });
    }
  }

  @Watch("cruises", { deep: true })
  cruiseParams(): void {
    if (!this.cruises || !this.cruises.length) return;
    this.cruise_id = this.cruises[0]._id;
    this.$nextTick(() => this.getGuests(String(this.cruises[0].id)));
  }
}
